export class ContentTypes {
    public static readonly Json = 'application/json';
    public static readonly Pdf = 'application/pdf';
    public static readonly Png = 'image/png';
    public static readonly Jpeg = 'image/jpeg';
    public static readonly Tiff = 'image/tiff';
    public static readonly Csv = 'text/csv';
    public static readonly CsvAlt1 = 'text/comma-separated-values';
    public static readonly CsvAlt2 = 'application/csv';
    public static readonly CsvAlt3 = '.csv';
    public static readonly Xls = 'application/vnd.ms-excel';
    public static readonly XlsAlt1 = 'application/vnd.msexcel';
    public static readonly XlsAlt2 = 'application/excel';
    public static readonly XlsAlt3 = '.xls';
    public static readonly Xlsx =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    public static readonly XlsxAlt1 = '.xlsx';
    public static readonly Zip = 'application/zip';

    public static ImagesAndPdfs = [
        ContentTypes.Pdf,
        ContentTypes.Png,
        ContentTypes.Jpeg,
        ContentTypes.Tiff
    ];

    public static Csvs = [
        ContentTypes.Csv,
        ContentTypes.CsvAlt1,
        ContentTypes.CsvAlt2,
        ContentTypes.CsvAlt3,
        ContentTypes.Xls,
        ContentTypes.XlsAlt1
    ];

    public static CsvsString = ContentTypes.Csvs.join(',');

    public static Spreadsheets = [
        ...ContentTypes.Csvs,
        ContentTypes.Xls,
        ContentTypes.XlsAlt1,
        ContentTypes.XlsAlt2,
        ContentTypes.XlsAlt3,
        ContentTypes.Xlsx,
        ContentTypes.XlsxAlt1
    ];
}
